import { Box, Button, Grid, Paper, Stack, Typography } from "@mui/material";

import COLORS from "../../../../styles/colors";
import { messages } from "./config/messages";
import { navigateToWhatsAppContact } from "../../../../utils/helpers";

import { EXPLORE_BY_STAGE } from "./constants";

const ExploreByStage = () => {
  return (
    <Stack
      spacing={6}
      justifyContent="center"
      alignItems="center"
      mt={6}
      mb={2}
      px={6}
    >
      <Typography color={COLORS.DARK_BLUE} fontWeight="600" fontSize="30px">
        {messages.exploreByStage}
      </Typography>
      {/* <Grid container justifyContent="space-evenly" alignItems="center" gap={2}>
        {IMAGES_MAP.map((imgPath, id) => (
          <Grid item xs={12} sm={9} md={3} lg={3} key={id}>
            <Paper
              component="img"
              src={imgPath}
              width="100%"
              sx={{ borderRadius: "25px" }}
              elevation={16}
            />
          </Grid>
        ))}
      </Grid> */}
      <Grid
        container
        justifyContent="space-evenly"
        alignItems="stretch"
        gap={2}
      >
        {EXPLORE_BY_STAGE.map((item) => (
          <Grid item xs={12} sm={9} md={3} lg={3} key={item.stage}>
            <Paper
              sx={{
                padding: 6,
                borderRadius: 2,
                height: "100%",
              }}
              elevation={2}
            >
              <Typography
                fontWeight="600"
                color={COLORS.DARK_BLUE}
                variant="h3"
                mb={3}
              >
                {item.stage}
              </Typography>
              <Stack spacing={5}>
                {item.descriptions.map((desc) => (
                  <Box key={desc.key}>
                    <Typography
                      fontWeight="600"
                      fontSize="16px"
                      color={COLORS.DARK_BLUE}
                      // display="inline"
                      // mr={1}
                    >
                      {desc.key}
                    </Typography>
                    <Typography
                      fontSize="14px"
                      color={COLORS.DARK_BLUE}
                      variant="body1"
                      // display="inline"
                    >
                      {desc.description}
                    </Typography>
                  </Box>
                ))}
              </Stack>
            </Paper>
          </Grid>
        ))}
      </Grid>
      <Box width="40vw">
        <Button
          variant="contained"
          size="large"
          fullWidth
          sx={{
            bgcolor: COLORS.DARK_BLUE,
            color: "white",
            fontSize: "16px",
            lineHeight: "23px",
            paddingBlock: "15px",
          }}
          onClick={navigateToWhatsAppContact}
        >
          {messages.getInTouch}
        </Button>
      </Box>
    </Stack>
  );
};

export default ExploreByStage;
